import React from "react";
import Title from "../../UI/organisms/Title/Title";
import { CallToOfferType } from "./Types";

import "./CallToOffer.scss";

const CallToOffer = () => {
  const publicUrl = process.env.PUBLIC_URL;
  const data: CallToOfferType[] = [
    {
      id: "empowernefro-hdf",
      title: {
        intro:
          "2023 e 2024 foi muito bom... 2025 foi espetacular... 2026 foi inesquecível e 2027 será Fantástico!",
        title: "EMPOWERNEFRO 2027",
      },
      flag: "Garanta sua vaga!",
      link: "/curso/empowernefro-hdf",
    },
    {
      id: "pos-graduacao",
      title: {
        intro:
          "Escreva seu Futuro na Nefrologia e Torne-se um Especialista de Alto Nível",
        title: "Pós-graduação",
      },
      flag: "Entre na lista de espera!",
      link: "https://forms.office.com/r/wkswujKzre",
    },
  ];

  return (
    <div className="all-call-to-offer">
      {data.map((item) => (
        <a href={item.link} className="call-to-offer" key={item.id}>
          <div
            className="call-to-offer__container"
            style={{
              backgroundImage: `url(${publicUrl}/img/parts/row-quantity.svg)`,
            }}
          >
            {item.flag && (
              <div className="call-to-offer__container--flag">{item.flag}</div>
            )}
            <Title info={item.title} tag="h2" />
            <div className="call-to-offer__container--button">
              EU QUERO <span>&#10148;</span>
            </div>
          </div>
        </a>
      ))}
    </div>
  );
};

export default CallToOffer;
